module.exports = __webpack_public_path__ + "static/media/hand.5640158c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/BottomBar/ManagedBottomBar/BottomBarHeader/hand.svg
// module id = 2197
// module chunks = 0